import { object, array, number, string } from '@gogame/schemas';

import { FILTER_EVENTS, FILTER_APPLICATIONS } from '../constants';

export const filtersSchema = object({
  [FILTER_APPLICATIONS]: array(number()),
  [FILTER_EVENTS]: array(string()),
}).stripEmpty();

export const EMPTY_FILTERS = filtersSchema.default();
